import * as React from 'react';
import { ScrollView, View } from 'react-native';
import { styles } from 'styles/components/productSoldList';
import ProductSoldItem from 'components/ProductSoldItem';
import ProductsSoldListProps from 'types/components/ProductsSoldListProps';

export default ({ products, children, isMediumScreen }: ProductsSoldListProps): JSX.Element => {

  const renderMediumScreen = (): JSX.Element => {
    return (
      <>
        <View>{children}</View>
        {/*
        <View style={styles.titleColumnSmall}>
          <TouchableOpacity
            style={selectedStatus == 'Pendiente' ? styles.cardHeaderSelectedSmall : styles.cardHeaderSmall}
            onPress={() => setSelectedStatus('Pendiente')}
          >
            <Text style={selectedStatus == 'Pendiente' ? styles.selectedText : styles.textSmall}>Pendientes</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={selectedStatus == 'En Proceso' ? styles.cardHeaderSelectedSmall : styles.cardHeaderSmall}
            onPress={() => setSelectedStatus('En Proceso')}
          >
            <Text style={selectedStatus == 'En Proceso' ? styles.selectedText : styles.textSmall}>En Proceso</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={selectedStatus == 'Por Entregar' ? styles.cardHeaderSelectedSmall : styles.cardHeaderSmall}
            onPress={() => setSelectedStatus('Por Entregar')}
          >
            <Text style={selectedStatus == 'Por Entregar' ? styles.selectedText : styles.textSmall}>Por Entregar</Text>
          </TouchableOpacity>
    </View>*/}
        <ScrollView style={styles.cardColumnSmall}>
          {products.length > 0 &&
            products
              .map((product: any, index) => {
                return (
                  <ProductSoldItem 
                  key={index}
                  product={product}
                  isMediumScreen={isMediumScreen}
                  />
                );
              })}
        </ScrollView>
      </>
    );
  };
  const renderLargeScreen = (): JSX.Element => {
    return (
      <>
        <View>{children}</View>
        <View style={styles.cardsContainerLarge}>
          <View style={styles.cardColumnLarge}>
            {products.length > 0 &&
              products
                .map((product: any, index) => {
                  return (
                    <ProductSoldItem
                      key={index}
                      product={product}
                      isMediumScreen={isMediumScreen}
                    />
                  );
                })}
          </View>
        </View>
      </>
    );
  };

  return <>{isMediumScreen ? renderLargeScreen() : renderMediumScreen()}</>;
};
